import { render, staticRenderFns } from "./payFreight.vue?vue&type=template&id=c166834e&"
import script from "./payFreight.vue?vue&type=script&lang=js&"
export * from "./payFreight.vue?vue&type=script&lang=js&"
import style0 from "./payFreight.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports